import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    page: false,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    addFormSlot: true,
    viewFormSlot: true,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '资产类型',
        prop: 'fireassetType',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 24,
        align: 'center',
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU077', value) : '';
        }
      },
      {
        label: '巡检项目',
        prop: 'patrolItemList',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        formatter: function (row, value) {
          const nameList = []
          if (value && value.length) {
            value.map(item =>{
              nameList.push(item.patrolItem)
            })
          }
          return nameList.join('')
        }
      }
    ]
  }
}
export default tableOption